import "./styles/App.scss";
import React, { useState, useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import Menu from "./components/NavBar/index";
import Body from "./components/body";

const App = () => {
  document.title = "Paul Sangha Creative | Landscape Architects";

  const [headerColor, setHeaderColor] = useState("#000000");
  const [menuColor, setMenuProperties] = useState("#000000");
  const [menuButtonColor, setMenuButtonColor] = useState("#000000");
  const [headerTransparent, setHeaderTransparency] = useState(false);

  const [isWebPSupported, setSupportWebP] = useState(true);
  const [projectCategory, setProjectCategory] = useState("");
  const [projectSlug, setProjectSlug] = useState("");
  const [selectedProject, setSelectedProject] = useState({});

  const [publications, setPublicationsStore] = useState([]);

  const [journals, setJournalsStore] = useState([]);
  const [selectedJournal, setSelectedJournal] = useState({});

  const setHeaderProperties = (color, isTransparent) => {
    setHeaderColor(color);
    setHeaderTransparency(isTransparent);
  };

  useEffect(() => {
    const hasWebPDataUrl =
      document
        .createElement("canvas")
        .toDataURL("image/webp")
        .indexOf("data:image/webp") === 0;
    setSupportWebP(hasWebPDataUrl);
  }, []);

  return (
    <Router>
      <div className='main'>
        <Menu
          headerColor={headerColor}
          menuButtonColor={menuButtonColor}
          menuColor={menuColor}
          isTransparent={headerTransparent}
          setProjectCategory={setProjectCategory}
        />
        <Body
          //Project Page and Project View related
          projectCategory={projectCategory}
          projectSlug={projectSlug}
          setProjectSlug={setProjectSlug}
          selectedProject={selectedProject}
          setSelectedProject={setSelectedProject}
          //Press
          setPublicationsStore={setPublicationsStore}
          publicationsStore={publications} //Help save another call to contentful
          //Journals
          journalsStore={journals} //Help save another call to contentful
          setJournalsStore={setJournalsStore}
          selectedJournal={selectedJournal}
          setSelectedJournal={setSelectedJournal}
          //UI States
          setHeaderProperties={setHeaderProperties}
          setMenuButtonColor={setMenuButtonColor}
          setMenuProperties={setMenuProperties}
          isWebPSupported={isWebPSupported}
        />
      </div>
    </Router>
  );
};

export default App;
